import { HTTP } from "./http";
let API_SERVER = "";
if (window.location.href.indexOf("8080") > -1) {
  API_SERVER = "http://www.localhost:8888/back-end-endpoint-training-plan.php";
} else {
  API_SERVER = "/personal-training-BE/back-end-endpoint-training-plan.php";
}

const TrainingPlan = {
  find(params) {
    return HTTP.post(API_SERVER, params);
  },

  show(id) {
    return HTTP.post(API_SERVER, { action: "getTrainingPlanById", id: id });
  },

  store(post) {
    return HTTP.post(API_SERVER, post);
  },

  update(post) {
    return HTTP.post(API_SERVER, { ...post, action: "edittrainingPlan" });
  },

  delete(params) {
    return HTTP.post(API_SERVER, params);
  },

  duplicate(planId) {
    return HTTP.post(API_SERVER, { action: "duplicateTrainingPlan", planId: planId });
  },
};

export { TrainingPlan };
